/**
 * 動画の「出だし」だけを先頭2MBに限定して取得し、ブラウザのHTTPキャッシュ／接続を温める。
 * サムネのホバー意図に応じて呼び出し、初回クリック→再生の開始を速める狙い。
 *
 * - 通信費が無駄に増えないよう **先頭2MBで打ち切り**、同一URLは1回だけ実行
 * - iOS（WebKitの先読み制限で効果が出ない）・Save-Data（データセーバー）時はスキップ
 */
const PREFETCH_HEAD_BYTES = 2 * 1024 * 1024 // 2MB

const prefetchedUrls = new Set<string>()

const isIosDevice = (): boolean => /iphone|ipad|ipod/i.test(navigator.userAgent)

const isSaveDataEnabled = (): boolean => {
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection
  return Boolean(connection?.saveData)
}

export const prefetchVideoHead = (videoUrl: string | null | undefined): void => {
  if (!videoUrl) return
  if (prefetchedUrls.has(videoUrl)) return
  if (isIosDevice() || isSaveDataEnabled()) return

  prefetchedUrls.add(videoUrl)
  fetch(videoUrl, {
    headers: { Range: `bytes=0-${PREFETCH_HEAD_BYTES - 1}` },
    mode: 'cors',
  }).catch(() => {
    // 失敗時は再試行できるよう記録を取り消す
    prefetchedUrls.delete(videoUrl)
  })
}
